import React from 'react';
import {
  Control,
  FieldValues,
  UseFormRegister,
  UseFormSetValue,
} from 'react-hook-form';
import { useSelector } from 'react-redux';

import AddToCartButton from './AddToCartButton';
import DeclineInterstitialProductButton from './DeclineInterstitialProductButton';
import DeclinePreCartOfferProductButton from './DeclinePreCartOfferProductButton';
import BackgroundsPosesSelector from './BackgroundsPosesSelector';
import RequiredProductForm from '../../required-product-form/RequiredProductForm.jsx';
import { DoneWrapper } from '../regularStyles';
import LegacyRequiredProductForm from '../../legacy-required-product-form/LegacyRequiredProductForm.jsx';
import PersonalizationForm from './PersonalizationForm';
import ProductMisconfiguredMessage from './ProductMisconfiguredMessage';
import CropOptionsPrepaySelector from './CropOptionsPrepaySelector';
import ProductOptionsSelector from './ProductOptionsSelector';
import SMSNumberConfirmation from './SMSNumberConfirmation';
import {
  selectShowCropOptions,
  selectShowDoneMessage,
  selectShowPersonalizationForm,
  selectShowSMSNumberConfirmation,
} from '../../../../../selectors';
import {
  useIsInterstitialFlow,
  useIsPreCartOfferFlow,
} from '../../../../../hooks/useOrderFlowContext';

interface ProductConfigurationStepsProps {
  addProductToCart: () => void;
  actionFooter?: React.ReactNode;
  control: Control<FieldValues>;
  register: UseFormRegister<FieldValues>;
  setValue: UseFormSetValue<FieldValues>;
}

const ProductConfigurationSteps: React.FC<ProductConfigurationStepsProps> = ({
  addProductToCart,
  actionFooter,
  control,
  register,
  setValue,
}) => {
  const product = useSelector(
    (state: any) => state.productConfig.currentProduct,
  );
  const isInterstitialProduct = useIsInterstitialFlow();
  const isPreCartOfferProduct = useIsPreCartOfferFlow();
  const showCropOptions = useSelector(selectShowCropOptions);
  const showPersonalizationForm = useSelector(selectShowPersonalizationForm);
  const showSMSNumberConfirmation = useSelector(
    selectShowSMSNumberConfirmation,
  );
  const showDoneMessage = useSelector(selectShowDoneMessage);

  if (!product) return null;

  return (
    <>
      {/* Sits above the picker: when it renders, the product cannot be
          completed at all, so it is the first thing to read. */}
      <ProductMisconfiguredMessage />
      <BackgroundsPosesSelector />
      {showPersonalizationForm && <PersonalizationForm />}
      {showSMSNumberConfirmation && <SMSNumberConfirmation />}
      {showDoneMessage && (
        <DoneWrapper>
          Configuration complete. Please click &apos;Add to Cart&apos;
        </DoneWrapper>
      )}
      <RequiredProductForm
        register={register}
        control={control}
        setValue={setValue}
      />
      <LegacyRequiredProductForm register={register} />
      {showCropOptions && <CropOptionsPrepaySelector />}
      <ProductOptionsSelector />
      <div className="hidden-md hidden-lg hidden-xl">
        <AddToCartButton addProductToCart={addProductToCart} />
        {actionFooter}
        {isInterstitialProduct && <DeclineInterstitialProductButton />}
        {isPreCartOfferProduct && <DeclinePreCartOfferProductButton />}
      </div>
    </>
  );
};

export default ProductConfigurationSteps;
